export enum OperationTransitionEnum {
    OPERATION_REQ_UNKNOWN = 'OPERATION_REQ_UNKNOWN',
    OPERATION_REQ_CREATE = 'OPERATION_REQ_CREATE',
    OPERATION_REQ_UPDATE = 'OPERATION_REQ_UPDATE',
    OPERATION_REQ_COORDINATE = 'OPERATION_REQ_COORDINATE',
    OPERATION_REQ_ACCEPT = 'OPERATION_REQ_ACCEPT',
    OPERATION_REQ_ACTIVATE = 'OPERATION_REQ_ACTIVATE',
    OPERATION_REQ_DEACTIVATE = 'OPERATION_REQ_DEACTIVATE',
    OPERATION_REQ_COMPLETE = 'OPERATION_REQ_COMPLETE',
    OPERATION_REQ_FINISH = 'OPERATION_REQ_FINISH',
    OPERATION_REQ_REMOVE = 'OPERATION_REQ_REMOVE',
    OPERATION_REQ_SUSPEND = 'OPERATION_REQ_SUSPEND',
    OPERATION_REQ_CANCEL = 'OPERATION_REQ_CANCEL',
    OPERATION_REQ_UNSUSPEND = 'OPERATION_REQ_UNSUSPEND',
    OPERATION_REQ_RESET = 'OPERATION_REQ_RESET',
    OPERATION_REQ_TEST = 'OPERATION_REQ_TEST',
    OPERATION_REQ_CLEAR = 'OPERATION_REQ_CLEAR',
}

export enum OperationTransitionStatusColorEnum {
    OPERATION_REQ_UNKNOWN = 'medium',
    OPERATION_REQ_CREATE = 'medium',
    OPERATION_REQ_UPDATE = 'medium',
    OPERATION_REQ_COORDINATE = 'zomp',
    OPERATION_REQ_ACCEPT = 'success',
    OPERATION_REQ_ACTIVATE = 'pistachio',
    OPERATION_REQ_DEACTIVATE = 'queenblue',
    OPERATION_REQ_COMPLETE = 'success',
    OPERATION_REQ_FINISH = 'dimmed',
    OPERATION_REQ_REMOVE = 'danger',
    OPERATION_REQ_SUSPEND = 'orangered',
    OPERATION_REQ_CANCEL = 'redsalsa',
    OPERATION_REQ_UNSUSPEND = 'pistachio',
    OPERATION_REQ_RESET = 'dark',
    OPERATION_REQ_TEST = 'primary',
    OPERATION_REQ_CLEAR = 'dimmed',
}